const SSO_CODE_VERIFIER_KEY = 'eliza_sso_code_verifier';

export const SSO_CODE_HANDOFF_VERSION = 'code_exchange_v1';

function base64UrlEncode(bytes: Uint8Array): string {
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export async function prepareSsoCodeExchange(): Promise<string> {
  if (!window.crypto?.getRandomValues || !window.crypto?.subtle) {
    throw new Error('Secure browser cryptography is unavailable.');
  }

  const verifier = base64UrlEncode(window.crypto.getRandomValues(new Uint8Array(32)));
  const verifierBytes = Uint8Array.from(
    verifier,
    (character) => character.charCodeAt(0),
  );
  const digest = await window.crypto.subtle.digest(
    'SHA-256',
    verifierBytes,
  );
  const challenge = base64UrlEncode(new Uint8Array(digest));

  try {
    window.sessionStorage.setItem(SSO_CODE_VERIFIER_KEY, verifier);
  } catch {
    throw new Error('Browser session storage is unavailable.');
  }

  return challenge;
}

export function getSsoCodeVerifier(): string | null {
  try {
    return window.sessionStorage.getItem(SSO_CODE_VERIFIER_KEY);
  } catch {
    return null;
  }
}

export function clearSsoCodeVerifier(): void {
  try {
    window.sessionStorage.removeItem(SSO_CODE_VERIFIER_KEY);
  } catch {
    // The verifier expires server-side; there is nothing else safe to do here.
  }
}
